import { atom } from 'jotai';

export const selectedSiteAtom = atom<number>();

export const selectedVerifyRouteAtom = atom<any>();
